import { Link } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen radial-fade flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <Seo title="Page not found (404)" noindex />
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-400 to-indigo-500 glow-cyan">
        <Compass className="h-8 w-8 text-[#041016]" />
      </div>
      <p className="font-mono-data text-sm uppercase tracking-[0.3em] text-cyan-400">Error 404</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white">This page took a wrong turn</h1>
      <p className="mt-4 max-w-md text-slate-400">
        The page you're looking for doesn't exist or has moved. Let's get you back on your career path.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" data-testid="notfound-home-btn"
          className="inline-flex items-center gap-2 rounded-full bg-cyan-400 px-7 py-3 text-sm font-bold text-[#041016] transition-transform hover:scale-105 glow-cyan">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <Link to="/counsellors" data-testid="notfound-counsellors-btn"
          className="inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3 text-sm font-bold text-slate-200 transition-all hover:border-cyan-400/50 hover:text-white">
          Explore counsellors
        </Link>
      </div>
    </div>
  );
}
